import { z } from 'zod';

/** Browser mirror, pinned by quoteResultAction.test.ts to the canonical server schema. Server-authored receipt of a verified create_quote success. No URLs or draft inputs. */
export const quoteResultActionSchema = z
  .object({
    kind: z.literal('quote'),
    version: z.literal(1),
    tenantId: z.string().uuid(),
    userId: z.string().uuid(),
    quoteId: z.string().uuid(),
    workOrderNumber: z.string().max(50).nullable(),
    focus: z.literal('services'),
    conversationId: z.string().uuid(),
    actionId: z.string().uuid(),
  })
  .strict();

export type QuoteResultAction = z.infer<typeof quoteResultActionSchema>;

/** Bind a receipt to its settled envelope; unknown, unrelated or malformed metadata is inert. */
export function boundQuoteResult(
  value: unknown,
  binding: { outcome: unknown; conversationId: unknown; actionId: unknown }
): QuoteResultAction | undefined {
  if (binding.outcome !== 'ok') return undefined;
  const parsed = quoteResultActionSchema.safeParse(value);
  return parsed.success &&
    parsed.data.conversationId === binding.conversationId &&
    parsed.data.actionId === binding.actionId
    ? parsed.data
    : undefined;
}
